var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('field-select-module',{attrs:{"board":this.board,"is-print":_vm.isPrint},model:{value:(_vm.form.stdInfo),callback:function ($$v) {_vm.$set(_vm.form, "stdInfo", $$v)},expression:"form.stdInfo"}}),_c('table-company-group',{staticClass:"mt-5",attrs:{"title":"관리자 그룹","list":_vm.form.group1,"isPrint":_vm.isPrint,"isReadonly":_vm.board.readonly,"positionList":[
      '대표이사',
      'CSO',
      '본부장',
      '부문장',
      '실장',
      '전무',
      '상무',
      '이사',
      '관리책임자',
      '안전부장',
      '공사부장',
      '공무부장',
      '품질부장',
      '관리부장',
      '부장',
      '과장',
      '대리',
      '사원',
      '담당',
      '책임',
      '선임',
    ]},on:{"updateList":_vm.updateGroupList}}),_c('file-upload-module',{staticClass:"mt-5",attrs:{"readonly":_vm.board.readonly,"is-print":_vm.isPrint},model:{value:(_vm.form.fileList),callback:function ($$v) {_vm.$set(_vm.form, "fileList", $$v)},expression:"form.fileList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }